export * from './lib/dom';